export default {
    newDesign: true,
    parameters: {
        landing_id: "LatQuI",
        segment: 44,
    },
    title: "Convierte el talento artístico de tu hijo en una habilidad con futuro | Kodland",
    downtimeUrl: "https://www.kodland.org/es",
    startPage: {
        title: "Portafolio que abre oportunidades",
        subtitle:
            "🎨 Proyectos reales para su portafolio<br>💬 Feedback de mentor en cada trabajo<br>🚀 Base para futuros encargos y freelance",
        image: {
            url: "/welcome/latam_illustration_v2_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/latam_illustration_v2_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "¡Empecemos! 🔥",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
    },
    quizRotateBySteps: {
        1: {
            title: "¿Cuántos años tiene tu hijo?",
            type: "age",
            button: "",
        },
        2: {
            question: "¿Qué tan interesado está tu hijo/a en la ilustración digital ahora?",
            answers: [
        {
          answer: "🖌️ La ilustración es una parte importante de su vida, le encanta",
          distribution_tag_question: [144],
        },
        {
          answer: "🎨 Tiene curiosidad y le gustaría aprender ilustración digital",
          distribution_tag_question: [144],
        },
        {
          answer: "🙂 Le gusta dibujar, pero aún no lo hace de forma estructurada",
          distribution_tag_question: [144],
        },
        {
          answer: "🤔 No está muy interesado en la ilustración (por ahora)",
          distribution_tag_question: [144],
        }
      ],
        },
        3: {
            question: "En este momento, ¿qué es lo más importante para ti en el desarrollo de tu hijo/a?",
            answers: [
                "🙂 Habilidades blandas (confianza, disciplina, enfoque)",
                "🎨 Desarrollar creatividad y autoexpresión",
                "🎓 Prepararlo para oportunidades futuras",
            ],
        },
        4: {
            question:
                "¿Para qué te gustaría que sirva este curso de ilustración?",
            answers: [
                "✨ Crear ilustraciones con estilo propio",
                "📁 Armar sus primeros proyectos o portafolio",
                "💻 Aprender habilidades digitales útiles para el futuro",
            ],
        },
        5: {
            question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
            answers: [
                "💻 Sí",
                {
                    answer: "😐 No",
                    stopAnswer: true
                },
            ],
        },
        6: {
            title: "¡Felicitaciones! 🎉",
            typeInfo: "congrats",
            subtitle:
                "Haz clic en '📆 Reservar una clase' para completar el registro",
            button: "📆 Reservar una clase",
        },
        7: {
            title: "Reserva una clase gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Casi terminamos 🔥",
        },
        8: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title: "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        10: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        11: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};
